import Wrapper from "./style"

export const Nav = () => {

    const gotoTop = e => {
        window.scrollTo(0,0);
        document.querySelector('.active').classList.remove('active')
        e.target.classList.toggle('active')
    }

    return (
        <Wrapper>
            <ul>
                <li className="active" onClick={gotoTop} >Market Sizing Assets</li>
            </ul>
        </Wrapper>
    )
}